<button mat-button [disabled]="isDisabled()" class="orbitax-flat-button" (click)="!isDisabled() && toggleStatus(!item.cells[fieldDefinition.key]?.value)">
  {{item.cells[fieldDefinition.key]?.displayText}}
</button>
